import Rest from 'services/data/rest';

export default class MfaConnectionLog extends Rest {
  static path = 'mfaconnectionlog';
}
